import { useState } from 'react';
import { useAiSidebarContext } from '@/creditflowresearch/application/AiSidebar/AiSidebarContext';
import { getMinViewportForSidebar } from '@/creditflowresearch/application/AiSidebar/constants';

const AiSidebarStyles = () => {
  const { width } = useAiSidebarContext();
  const [serverWidth] = useState(width);

  if (!serverWidth) return null;

  return (
    <style
      dangerouslySetInnerHTML={ {
        __html: `@media (min-width: ${ getMinViewportForSidebar(serverWidth) }px) {
          :root { --cfr-sidebar-width: ${ serverWidth }px; }
        }`,
      } }
    />
  );
};

export default AiSidebarStyles;
